module.exports = __webpack_public_path__ + "img/wechat.78ffad30.jpg";